import type { ID } from '@octopus-do/octopus-project-core'
import type { Thread } from '@store/reducers/threads'
import type React from 'react'

import type { Recipient } from '@/types'
import { clsJoin } from '@/utils'
import { useCardSide, useThreadItem } from '../../hooks'
import { ThreadBubble } from '../ThreadBubble'
import { ThreadComments } from '../ThreadComments'
import { ThreadDraggable } from '../ThreadDraggable'
import css from './styles.module.css'

interface Props {
  active: boolean
  scale: number
  users: Record<ID, Recipient>
  thread: Thread
}

export const ThreadItem: React.FC<Props> = ({
  thread,
  users,
  active,
  scale,
}) => {
  const { ref, comments, onClick } = useThreadItem(thread, active)
  const side = useCardSide(ref, active, thread.offset)

  // the canvas scales the whole tree, the thread keeps its on-screen size
  const compensation = { transform: `scale(${1 / scale})` }

  return (
    <ThreadDraggable
      scale={scale}
      open={active}
      thread={thread}
      cancel={`.${css.thread_content}`}
    >
      <div className={css.thread_item} ref={ref} style={compensation}>
        <ThreadBubble
          onClick={onClick}
          active={active}
          users={users}
          thread={thread}
          comments={comments}
        />
        {/* mounted on open, so the reply field can take the focus */}
        {active && (
          <div
            className={clsJoin(css.thread_content, side === 'left' && css.left)}
          >
            <ThreadComments users={users} comments={comments} thread={thread} />
          </div>
        )}
      </div>
    </ThreadDraggable>
  )
}
